import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import GeneralBackref from "./GeneralBackref";

export default function TeyaBackref() {
  const [searchParams] = useSearchParams();

  const [orderUUID, setOrderUUID] = useState(null);
  const [transactionID, setTransactionID] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaded(true);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    setTransactionID(searchParams.get("transactionID"));
    setOrderUUID(searchParams.get("extID"));
    // eslint-disable-next-line
  }, []);

  return (
    <GeneralBackref
      loading={!loaded}
      success={true}
      transactionID={transactionID}
      errorMessage={""}
      orderUUID={orderUUID}
      paymentAgent={"TeyaSecurePay"}
    />
  );
}
